import {
    Configuration,
    DashboardApi,
    ExplanationApi,
    FlatsApi,
    LogsApi,
    ProjectsApi,
    UptimeEventsApi,
    UserAuthApi
} from './swagger';

export const apiConfiguration = new Configuration();

/*export function setAccessToken(token: string) {
    apiConfiguration = new Configuration({
        accessToken: token,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}*/

interface Apis {
    flats: FlatsApi,
    explanation: ExplanationApi,
    projects: ProjectsApi,
    logs: LogsApi,
    dashboards: DashboardApi,
    userAuth: UserAuthApi,
    uptimeEvents: UptimeEventsApi,
}

function reloadApi(): Apis {
    return {
        projects: new ProjectsApi(apiConfiguration),
        explanation: new ExplanationApi(apiConfiguration),
        flats: new FlatsApi(apiConfiguration),
        logs: new LogsApi(apiConfiguration),
        dashboards: new DashboardApi(apiConfiguration),
        userAuth: new UserAuthApi(apiConfiguration),
        uptimeEvents: new UptimeEventsApi(apiConfiguration),
    };
}

let apiInstance: Apis;

export function api(): Apis {
    if (!apiInstance) {
        apiInstance = reloadApi();
    }

    return apiInstance;
}
